import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { ErrorBoundary } from '@catchup/ui';
import RespondPage from './pages/RespondPage';
import InvitePage from './pages/InvitePage';
import GroupInvitePage from './pages/GroupInvitePage';
import PromoCardComparison from './pages/PromoCardComparison';
import InviteSubmittedPreview from './pages/InviteSubmittedPreview';
import AvailabilityPickerPreview from './pages/AvailabilityPickerPreview';
import LandingStyleguidePage from './pages/LandingStyleguidePage';
import { HomePage, PrivacyPage, TermsPage } from './pages/CompliancePages';

// Initialize Convex client with diagnostic logging
const convexUrl = import.meta.env.VITE_CONVEX_URL as string;
console.log('[App] Initializing Convex client with URL:', convexUrl);

const convex = convexUrl
  ? new ConvexReactClient(convexUrl, {
      // Add connection state logging
      verbose: true,
    })
  : null;

// Monitor WebSocket connection state
if (typeof window !== 'undefined' && convexUrl) {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    console.log('[App] Fetch intercepted:', args[0]);
    const result = await originalFetch(...args);
    console.log('[App] Fetch completed:', args[0], 'status:', result.status);
    return result;
  };
}

function App() {
  const routes = (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Story 4.2: Magic Link PWA Loading */}
        <Route path="/i/:token" element={<InvitePage />} />
        <Route path="/g/:token" element={<GroupInvitePage />} />
        {/* Legacy route for backwards compatibility */}
        <Route path="/respond/:token" element={<RespondPage />} />
        {/* Promo card comparison page */}
        <Route path="/promo-cards" element={<PromoCardComparison />} />
        {/* Design preview: Thanks/Submitted screen */}
        <Route path="/preview/invite-submitted" element={<InviteSubmittedPreview />} />
        {/* Design preview: Availability Picker */}
        <Route path="/preview/availability-picker" element={<AvailabilityPickerPreview />} />
        {/* Design preview: Landing homepage styleguide */}
        <Route path="/preview/landing-styleguide" element={<LandingStyleguidePage />} />
      </Routes>
    </BrowserRouter>
  );

  return (
    <ErrorBoundary>
      {convex ? <ConvexProvider client={convex}>{routes}</ConvexProvider> : routes}
    </ErrorBoundary>
  );
}

export default App;
